import { useEffect, useMemo } from "react";
import { useGLTF } from "@react-three/drei";
import { RigidBody } from "@react-three/rapier";
import * as THREE from "three";

export default function Table({
  position = [22.09, -0.07, 43.84],
  rotation = [0, 0, 0],
  scale = 1,
  ...rigidBodyProps
}) {
  const { scene } = useGLTF("/table.glb");
  const tableScene = useMemo(() => scene.clone(true), [scene]);

  useEffect(() => {
    tableScene.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
  }, [tableScene]);

  return (
    <RigidBody
      type="fixed"
      colliders="trimesh"
      position={position}
      rotation={rotation}
      {...rigidBodyProps}
    >
      <group scale={scale}>
        <primitive object={tableScene} />
      </group>
    </RigidBody>
  );
}

useGLTF.preload("/table.glb");
